import { render, staticRenderFns } from "./SocialPostComment.vue?vue&type=template&id=7fcc9555&"
import script from "./SocialPostComment.vue?vue&type=script&lang=js&"
export * from "./SocialPostComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fcc9555')) {
      api.createRecord('7fcc9555', component.options)
    } else {
      api.reload('7fcc9555', component.options)
    }
    module.hot.accept("./SocialPostComment.vue?vue&type=template&id=7fcc9555&", function () {
      api.rerender('7fcc9555', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialPostComment.vue"
export default component.exports